import { render } from "./DashedBorder.vue?vue&type=template&id=f977d452"
const script = {}

import exportComponent from "/home/krists/Documents/git/bomb-game/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__